import { Col, Row } from 'antd';
import { type ReactNode } from 'react';
import styled from 'styled-components';

const ActionButtonWrapper = styled.div`
  .ant-btn-default {
    border-color: ${props => props.theme.moduleDelegateColor};
  }
`;

export interface IActionButtonContainerProps {
  message?: ReactNode;
  button?: ReactNode;
}

export function ActionButtonContainer(props: IActionButtonContainerProps) {
  const { message, button } = props;
  return (
    <Row align="middle" gutter={[24, 12]}>
      <Col xs={24} sm={24} md={24} lg={12}>
        {message}
      </Col>
      <Col xs={24} sm={24} md={24} lg={12}>
        <ActionButtonWrapper>{button}</ActionButtonWrapper>
      </Col>
    </Row>
  );
}
